import { useEffect, useState } from 'react'

/**
 * Which of the three viewer designs applies.
 *
 * These are not cosmetic breakpoints. A broadsheet is 792 points wide and a
 * phone is 390: the page cannot be made to fit, so each width gets its own
 * arrangement rather than a squeezed version of the one above it. The tablet
 * drops the edition rail and moves the controls under the page; the phone
 * makes the page the whole screen and puts everything else in one sheet.
 */
export type Breakpoint = 'mobile' | 'tablet' | 'desktop'

function measure(): Breakpoint {
  if (typeof window === 'undefined') return 'desktop'
  const width = window.innerWidth
  if (width < 700) return 'mobile'
  if (width < 1200) return 'tablet'
  return 'desktop'
}

export function useBreakpoint(): Breakpoint {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(measure)
  useEffect(() => {
    const onResize = () => setBreakpoint(measure())
    window.addEventListener('resize', onResize)
    onResize()
    return () => window.removeEventListener('resize', onResize)
  }, [])
  return breakpoint
}
